import { AuthService } from '@/services/auth.service';
import type { User } from '@/types';
import { useQuery } from '@tanstack/react-query';

interface UseAuthQueryOptions {
  refetchOnMount?: boolean | 'always';
}

export function useAuthQuery({ refetchOnMount }: UseAuthQueryOptions = {}) {
  return useQuery({
    queryKey: ['auth', 'profile'],
    queryFn: (): Promise<User> => AuthService.profile(),
    retry: false,
    staleTime: 1000 * 60 * 5,
    refetchOnMount,
  });
}
